import { Component, Mixins } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import { State } from 'vuex-class'
import store, { Mutations } from '../../store'
import { IChargifyAccount, IOnboardingPayload } from '@/firestore'
import BrandLogo from '@/components/BrandLogo.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import axios, { AxiosError } from 'axios'

@Component({
  components: {
    BrandLogo,
    LoadingPage
  }
})
export default class NewGroup extends Mixins(IconsMixin, AuthMixin) {
  @State('onboarding') public onboarding!: IOnboardingPayload | null

  private _groupName = ''
  public get groupName() {
    return this.onboarding
      ? this.onboarding.groupName
      : this._groupName
  }

  public set groupName(name) {
    if (this.onboarding) {
      this.onboarding.groupName = name
    }
    this._groupName = name
  }

  public loading = true
  public valid: boolean = false
  public error: string = ''
  public tokenError = ''

  public async mounted() {
    let onboardingToken: string
    let chargifyAccount: IChargifyAccount

    if (
      this.$route.query
      && this.$route.query.onboarding_token
      && typeof this.$route.query.onboarding_token === 'string'
    ) {
      try {
        onboardingToken = this.$route.query.onboarding_token
        const res = await axios.post('/api/onboarding/jwt', {
          onboarding_token: onboardingToken
        })
        chargifyAccount = res.data
      } catch (err) {
        let message: string = err.response.data.message
        message = message.split(' ')
          .map(s => s.charAt(0).toUpperCase() + s.slice(1))
          .join(' ')
        this.tokenError = message || 'An Unknown Error Has Occurred'
        return
      }
    } else {
      this.tokenError = 'Invalid Onboarding Token'
      return
    }

    if (!this.onboarding) {
      store.commit(Mutations.UPDATE_ONBOARDING, {
        onboarding: {
          groupName: '',
          admin: {
            name: '',
            phoneNumber: ''
          },
          restaurants: [],
          subscriptionId: chargifyAccount.subscriptionId,
          restaurantLimit: chargifyAccount.componentQty,
          token: onboardingToken
        }
      })
    } else {
      store.commit(Mutations.UPDATE_ONBOARDING, {
        onboarding: {
          ...this.onboarding,
          subscriptionId: chargifyAccount.subscriptionId,
          restaurantLimit: chargifyAccount.componentQty,
          token: onboardingToken
        }
      })
    }

    this.loading = false
  }

  public addRestaurants() {
    store.commit(Mutations.UPDATE_ONBOARDING, {
      onboarding: {
        ...this.onboarding,
        groupName: this.groupName
      }
    })

    this.$router.push({name: 'add-restaurants'})
  }
}
